export default __webpack_public_path__ + "static/media/unnamed_redo.efc20266.svg";